<template>
  <div class="perfis-step-dados">
    <FormField
      label="Nome do perfil"
      v-model="local.nome"
      :validation="$v.local.nome"
      placeholder="Ex.: Vendedores internos"
      @input="emitDirty"
    />
    <FormField
      label="Descrição"
      v-model="local.descricao"
      placeholder="Opcional — objetivo ou regra do perfil"
      @input="emitDirty"
    />
    <FormSwitch
      v-model="local.ativo"
      label="Perfil ativo"
      @change="emitDirty"
    />
    <PerfisInfoAlert>
      No passo seguinte você poderá restringir planos de pagamento LifeGrowth.
      O vínculo de usuários ao perfil é feito na tela de usuários.
    </PerfisInfoAlert>
  </div>
</template>

<script>
import FormField from "@/components/form/FormField";
import FormSwitch from "@/components/form/FormSwitch";
import PerfisInfoAlert from "./PerfisInfoAlert";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PerfisUsuarioStepDados",
  components: { FormField, FormSwitch, PerfisInfoAlert },
  props: {
    wizardState: { type: Object, required: true }
  },
  validations: {
    local: {
      nome: { required }
    }
  },
  data() {
    return {
      local: {
        nome: this.wizardState.nome,
        descricao: this.wizardState.descricao,
        ativo: this.wizardState.ativo
      }
    };
  },
  watch: {
    wizardState: {
      deep: true,
      handler(val) {
        this.local.nome = val.nome;
        this.local.descricao = val.descricao;
        this.local.ativo = val.ativo;
      }
    }
  },
  methods: {
    emitDirty() {
      this.$emit("update-fields", { ...this.local });
      this.$emit("dirty");
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    syncToState() {
      this.$emit("update-fields", { ...this.local });
    }
  }
};
</script>
